import { MessageCircle } from 'lucide-react';

const WHATSAPP_LINK = "https://wa.me/5541988451399?text=Olá,%20gostaria%20de%20agendar%20uma%20avaliação%20médica.";

export const WhatsAppWidget = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-widget"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 group"
      aria-label="Falar pelo WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="font-medium text-sm hidden sm:inline-block">
        Fale conosco
      </span>
      
      {/* Pulse animation */}
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#B8944D] rounded-full animate-ping opacity-75" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#B8944D] rounded-full" />
    </a>
  );
};
